export * from './src/iam-signon-v1-sign-on-policy-sign-on-policy.meta.js';
